import { defaultMeta } from '@/constants/defaultMeta';
import { parseDateRangeSearch } from '@/lib/parseDateRange';
import { sortBy } from '@/lib/sortBy';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { affiliateLogQueries } from '@/services/payment/affiliate/affiliate.queries';
import { useSearch } from '@tanstack/react-router';

export const useGetAffiliateLog = () => {
  const { sort, createdDate, page, fetch } = useSearch({ from: '/(app)/payment-management/affiliate-log/' });

  // No date in the URL falls back to today, matching the toolbar's "today" preset (as in the reservation ledger).
  const parsedDateRange = parseDateRangeSearch(Array.isArray(createdDate) ? createdDate.join(',') : createdDate);

  const { data, isFetched, isLoading } = useQuery({
    ...affiliateLogQueries.list({
      fromDate: parsedDateRange.start,
      toDate: parsedDateRange.end,
      row: page ?? 0,
      fetch: fetch ?? 10,
    }),
    select: (res) => ({
      ...res,
      // An empty result comes back as `data: null` ("Record not found").
      data: sortBy(res.data ?? [], sort, { monthAndYear: 'monthNumber', createdDate: 'withdrawDate' }),
    }),
  });

  return {
    affiliateData: data?.data || [],
    isFetched,
    isLoading,
    pagination: data?.meta?.pagination ?? defaultMeta,
    dateRange: parsedDateRange,
  };
};

export default useGetAffiliateLog;
